import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Medias\MediaController::getById
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}'
*/
export const getById = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getById.url(args, options),
    method: 'get',
})

getById.definition = {
    methods: ["get","head"],
    url: '/api/media/{media}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Medias\MediaController::getById
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}'
*/
getById.url = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { media: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { media: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            media: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return getById.definition.url
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Medias\MediaController::getById
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}'
*/
getById.get = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getById.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::getById
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}'
*/
getById.head = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: getById.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::getBackgroundGallery
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/background-gallery'
*/
export const getBackgroundGallery = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getBackgroundGallery.url(options),
    method: 'get',
})

getBackgroundGallery.definition = {
    methods: ["get","head"],
    url: '/api/media/background-gallery',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Medias\MediaController::getBackgroundGallery
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/background-gallery'
*/
getBackgroundGallery.url = (options?: RouteQueryOptions) => {
    return getBackgroundGallery.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Medias\MediaController::getBackgroundGallery
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/background-gallery'
*/
getBackgroundGallery.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getBackgroundGallery.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::getBackgroundGallery
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/background-gallery'
*/
getBackgroundGallery.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: getBackgroundGallery.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::update
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}'
*/
export const update = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/api/media/{media}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Medias\MediaController::update
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}'
*/
update.url = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { media: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { media: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            media: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return update.definition.url
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Medias\MediaController::update
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}'
*/
update.put = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::setFavorite
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/set-favorite'
*/
export const setFavorite = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: setFavorite.url(args, options),
    method: 'put',
})

setFavorite.definition = {
    methods: ["put"],
    url: '/api/media/{media}/set-favorite',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Medias\MediaController::setFavorite
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/set-favorite'
*/
setFavorite.url = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { media: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { media: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            media: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return setFavorite.definition.url
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Medias\MediaController::setFavorite
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/set-favorite'
*/
setFavorite.put = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: setFavorite.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::upscale
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/upscale'
*/
export const upscale = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: upscale.url(args, options),
    method: 'get',
})

upscale.definition = {
    methods: ["get","head"],
    url: '/api/media/{media}/upscale',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Medias\MediaController::upscale
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/upscale'
*/
upscale.url = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { media: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { media: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            media: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return upscale.definition.url
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Medias\MediaController::upscale
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/upscale'
*/
upscale.get = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: upscale.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::upscale
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/upscale'
*/
upscale.head = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: upscale.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::colorizer
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/colorizer'
*/
export const colorizer = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: colorizer.url(args, options),
    method: 'get',
})

colorizer.definition = {
    methods: ["get","head"],
    url: '/api/media/{media}/colorizer',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Medias\MediaController::colorizer
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/colorizer'
*/
colorizer.url = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { media: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { media: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            media: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return colorizer.definition.url
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Medias\MediaController::colorizer
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/colorizer'
*/
colorizer.get = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: colorizer.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::colorizer
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/colorizer'
*/
colorizer.head = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: colorizer.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::blur
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/blur'
*/
export const blur = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: blur.url(args, options),
    method: 'get',
})

blur.definition = {
    methods: ["get","head"],
    url: '/api/media/{media}/blur',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Medias\MediaController::blur
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/blur'
*/
blur.url = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { media: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { media: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            media: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return blur.definition.url
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Medias\MediaController::blur
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/blur'
*/
blur.get = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: blur.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::blur
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/blur'
*/
blur.head = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: blur.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::backgroundRemover
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/background-remover'
*/
export const backgroundRemover = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: backgroundRemover.url(args, options),
    method: 'get',
})

backgroundRemover.definition = {
    methods: ["get","head"],
    url: '/api/media/{media}/background-remover',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Medias\MediaController::backgroundRemover
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/background-remover'
*/
backgroundRemover.url = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { media: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { media: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            media: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return backgroundRemover.definition.url
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Medias\MediaController::backgroundRemover
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/background-remover'
*/
backgroundRemover.get = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: backgroundRemover.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::backgroundRemover
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/background-remover'
*/
backgroundRemover.head = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: backgroundRemover.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::backgroundChange
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/background-changer'
*/
export const backgroundChange = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: backgroundChange.url(args, options),
    method: 'get',
})

backgroundChange.definition = {
    methods: ["get","head"],
    url: '/api/media/{media}/background-changer',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Medias\MediaController::backgroundChange
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/background-changer'
*/
backgroundChange.url = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { media: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { media: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            media: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return backgroundChange.definition.url
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Medias\MediaController::backgroundChange
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/background-changer'
*/
backgroundChange.get = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: backgroundChange.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::backgroundChange
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/background-changer'
*/
backgroundChange.head = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: backgroundChange.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::destroy
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}'
*/
export const destroy = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/api/media/{media}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Medias\MediaController::destroy
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}'
*/
destroy.url = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { media: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { media: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            media: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return destroy.definition.url
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Medias\MediaController::destroy
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}'
*/
destroy.delete = (args: { media: string | number | { id: string | number } } | [media: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::undo
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/undo-delete'
*/
export const undo = (args: { media: string | number } | [media: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/media/{media}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Medias\MediaController::undo
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/undo-delete'
*/
undo.url = (args: { media: string | number } | [media: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { media: args }
    }

    if (Array.isArray(args)) {
        args = {
            media: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        media: args.media,
    }

    return undo.definition.url
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Medias\MediaController::undo
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/undo-delete'
*/
undo.get = (args: { media: string | number } | [media: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Medias\MediaController::undo
* @see app/Http/Controllers/Medias/MediaController.php
* @route '/api/media/{media}/undo-delete'
*/
undo.head = (args: { media: string | number } | [media: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const MediaController = { getById, getBackgroundGallery, update, setFavorite, upscale, colorizer, blur, backgroundRemover, backgroundChange, destroy, undo }

export default MediaController